<template>
  <div>
    <p class="ba-mb-2 ba-text-xs ba-text-text-blue-grey">
      {{ $t("joinUserToCompany") }}
    </p>
    <div class="ba-text-center ba-py-8 ba-px-6 lg:ba-px-10">
      <h4>Подтвердите профиль через ЕСИА</h4>
      <p class="ba-mb-6">
        Для подачи заявки на услугу Вам необходимо подтвердить свой профиль в
        ЕСИА.
      </p>
      <div>
        <vis-button
          type="button"
          color="brand"
          text-color="white"
          rounded
          label="Подтвердить через ЕСИА"
          class="ba-text-center ba-px-10 ba-flex-grow ba-text-sm ba-mb-6"
          @click.prevent="onVerifyProfile"
        />
      </div>
    </div>

    <div class="ba-flex ba-justify-center">
      <div class="ba-w-10 ba-h-10 ba-mr-2 ba-text-success" v-if="!started">
        <label
          :title="$t('inn')"
          class="
            ba-inline-flex
            ba-justify-center
            ba-items-center
            ba-w-full
            ba-h-full
            ba-border
            ba-border-current
            ba-rounded-full
            ba-cursor-pointer
            ba-opacity-85
            hover:ba-opacity-100
          "
        >
          ИНН
          <input type="text" name="" v-model="inn" />
        </label>
        <vis-button
          @click.prevent="onBeginJoin"
          :disabled="!inn"
          label="Присоединить организацию"
        />
      </div>
      <div v-if="started">Запрос обрабатывается</div>
    </div>
  </div>
</template>

<script>
import rhmApi from "@/api/rhm-api";
import globalState from "@/shared/global-state";
import errorMessage from "@/shared/error-message";
import esiaService from "@/shared/esia-service";

export default {
  name: "vis-join-user-to-company",
  props: {},
  data() {
    return {
      inn: null,
      started: false,
      canJoin: false,
    };
  },
  async created() {
    let user = globalState.currentUser;
    this.canJoin = await rhmApi.joinUserToCompany.canJoin(user.ID);
  },
  methods: {
    onVerifyProfile() {
      esiaService.verifyRedirect({
        name: "joinUserToCompany",
      });
    },
    async onBeginJoin() {
      try {
        let user = globalState.currentUser;
        await rhmApi.joinUserToCompany.beginJoin(user.ID, this.inn);
        this.started = true;
      } catch (e) {
        this.$visNotification.error(await errorMessage(e));
      }
    },
  },
};
</script>
